import { z } from "zod";

export const orgBillingTransferCandidatesQuerySchema = z.object({
    organizationId: z.string().uuid(),
    clientId: z.string().uuid(),
});

export const initiateOrgBillingTransferRequestBodySchema = z.object({
    organizationId: z.string().uuid(),
    clientId: z.string().uuid(),
    newPrimaryAdminUserUuid: z.string().uuid().optional(),
});

export const orgBillingTransferRequestPathParamsSchema = z.object({
    requestId: z.string().uuid(),
});

export const cancelOrgBillingTransferRequestBodySchema = z.object({
    organizationId: z.string().uuid(),
});

export const acceptOrgBillingTransferRequestBodySchema = z.object({
    intentId: z.string().min(1),
});

export const DECLINE_REASON_MAX_LENGTH = 500;

export const declineOrgBillingTransferRequestBodySchema = z.object({
    reason: z
        .string()
        .trim()
        .max(DECLINE_REASON_MAX_LENGTH)
        .optional()
        .transform((reason) => reason || null),
});

export const pendingOrgBillingTransferRequestQuerySchema = z.object({
    workspaceId: z.string().uuid(),
});
